<template></template>
<script>
export default {
  data() {
      return {}
  },
  watch: {
    ssoSDK: {
      handler() {
        this.getData();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ssoSDK: function () {
      return this.$store.state.appData.ssoSDK;
    },
  },
  methods: {
    getData() {
      try {
        oauthSDK
          .getServiceList({})
          .then((res) => {})
          .catch((err) => {
            this.defalutToast(err.message);
          });
      } catch (error) {
      }
    },
  },
  mounted() {},
};
</script>